export default "__VITE_ASSET__CIYYDHVr__"